import React from "react";
import Constaint from "../../../layout/components/Constaint";
import { ReactComponent as SVBullet } from "../../../../../images/icons/sv-bullet-icon.svg";
import { Volume2, Settings } from "lucide-react";
import { inputModeFeatures, keyBenefits, responseModeFeatures } from "./data";
import StartMockBtn from "./StartMockBtn";
import { AiOutlineComment } from "react-icons/ai";

const FiBiChoices = () => {
  return (
    <div className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <Constaint>
        <div className="mx-auto max-w-7xl">
          {/* Header Section */}
          <div className="mb-16 text-center">
            <div className="flex items-center justify-center gap-3 mb-6">
              <SVBullet />
              <h1 className="text-5xl font-bold text-gray-900 font-spartan">
                FiBi AI Trainer
              </h1>
              <AiOutlineComment className="w-10 h-10 text-primaryColor" />
              {/* <Sparkles className="w-10 h-10 text-primaryColor" /> */}
            </div>
            <p className="max-w-3xl mx-auto text-xl leading-relaxed text-gray-600">
              Your personalized AI interview coach with complete communication
              flexibility. Choose how you interact and how FiBi responds to
              create your perfect training experience.
            </p>
          </div>

          {/* Main Features Grid */}
          <div className="grid gap-12 mb-16 lg:grid-cols-2">
            {/* Input Modes Section */}
            <div className="p-8 bg-white border border-gray-100 shadow-xl rounded-2xl">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-[#EAC5FC]/20 rounded-xl">
                  <Settings className="w-6 h-6 text-primaryColor" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">
                    Input Modes
                  </h2>
                  <p className="text-gray-600">Choose how you communicate</p>
                </div>
              </div>

              <div className="space-y-4">
                {inputModeFeatures.map((mode, index) => (
                  <div
                    key={index}
                    className="group p-5 bg-gray-50 hover:bg-[#EAC5FC]/10 rounded-xl border border-gray-200 hover:border-primtext-primaryColor/30 transition-all duration-200"
                  >
                    <div className="flex items-start gap-4">
                      <div className="p-2 transition-shadow bg-white rounded-lg shadow-sm group-hover:shadow-md">
                        <div className="text-primaryColor">{mode.icon}</div>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                          <h3 className="font-semibold text-gray-900">
                            {mode.label}
                          </h3>
                          <span className="px-2 py-1 text-xs font-medium rounded-full bg-primaryColor/10 text-primaryColor">
                            {mode.highlight}
                          </span>
                        </div>
                        <p className="text-sm leading-relaxed text-gray-600">
                          {mode.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Response Modes Section */}
            <div className="p-8 bg-white border border-gray-100 shadow-xl rounded-2xl">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-[#EAC5FC]/20 rounded-xl">
                  <Volume2 className="w-6 h-6 text-primaryColor" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">
                    Response Modes
                  </h2>
                  <p className="text-gray-600">Choose how FiBi responds</p>
                </div>
              </div>

              <div className="space-y-4">
                {responseModeFeatures.map((mode, index) => (
                  <div
                    key={index}
                    className="group p-5 bg-gray-50 hover:bg-[#EAC5FC]/10 rounded-xl border border-gray-200 hover:border-primtext-primaryColor/30 transition-all duration-200"
                  >
                    <div className="flex items-start gap-4">
                      <div className="p-2 transition-shadow bg-white rounded-lg shadow-sm group-hover:shadow-md">
                        <div className="text-primaryColor">{mode.icon}</div>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                          <h3 className="font-semibold text-gray-900">
                            {mode.label}
                          </h3>
                          <span className="px-2 py-1 text-xs font-medium rounded-full bg-primaryColor/10 text-primaryColor">
                            {mode.highlight}
                          </span>
                        </div>
                        <p className="text-sm leading-relaxed text-gray-600">
                          {mode.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Key Benefits Section */}
          <div className="bg-gradient-to-r from-[#EAC5FC]/20 to-primtext-primaryColor/20 rounded-2xl p-8 mb-12 border border-primtext-primaryColor/20">
            <h3 className="mb-8 text-2xl font-bold text-center text-gray-900">
              Here’s why thousands of applicants trust FiBi AI for their U.S.
              visa interviews
            </h3>
            <div className="grid gap-6 md:grid-cols-3">
              {keyBenefits.map((benefit, index) => (
                <div key={index} className="text-center">
                  <div className="inline-flex p-3 mb-4 bg-white shadow-sm rounded-xl">
                    <div className="text-primaryColor">{benefit.icon}</div>
                  </div>
                  <h4 className="mb-2 font-semibold text-gray-900">
                    {benefit.title}
                  </h4>
                  <p className="text-sm text-gray-600">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center">
            <StartMockBtn />
            <p className="mt-4 text-sm text-gray-500">
              Configure your preferred modes once you start your session
            </p>
          </div>
        </div>
      </Constaint>
    </div>
  );
};

export default FiBiChoices;
